import { UserTagComponent } from "@/global/user-tag.component";
import { BinderDrafter } from "@/models/engineering-models.model";
import { UserData } from "@/models/user-data.model";
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-people-column',
    template: `
            <div *ngIf="value">
                <app-user-tag *ngFor="let person of value" [user]="person.Users"></app-user-tag>
              </div>
    `,
    standalone: true,
    imports: [
        CommonModule,
        UserTagComponent
    ],
    styles: [
        `
        `
    ]
})

export class PeopleColumnComponent {
@Input() value: BinderDrafter[] = [];
}